const FALLBACK_SMS_ERROR = "Impossible d'envoyer le SMS. Veuillez réessayer.";

const pickMessage = (parsed: unknown): string | null => {
  if (!parsed) {
    return null;
  }
  if (typeof parsed === 'string' && parsed.trim()) {
    return parsed;
  }
  if (typeof parsed !== 'object') {
    return null;
  }

  const body = parsed as Record<string, any>;
  if (typeof body.error === 'string' && body.error.trim()) {
    return body.error;
  }
  if (typeof body.error?.message === 'string' && body.error.message.trim()) {
    return body.error.message;
  }
  if (typeof body.message === 'string' && body.message.trim()) {
    return body.message;
  }

  const nested = body.data?.[0]?.messages?.[0]?.message;
  if (typeof nested === 'string' && nested.trim()) {
    return nested;
  }

  return null;
};

export const getSmsApiErrorMessage = (
  error: unknown,
  fallback = FALLBACK_SMS_ERROR
): string => {
  const raw = error instanceof Error ? error.message : String(error ?? '');
  if (!raw) {
    return fallback;
  }

  try {
    const fromBody = pickMessage(JSON.parse(raw));
    if (fromBody) {
      return fromBody;
    }
  } catch {
    if (!raw.startsWith('{') && !raw.startsWith('[')) {
      return raw;
    }
  }

  return fallback;
};

const pickRetryAfterSeconds = (parsed: unknown): number => {
  if (!parsed || typeof parsed !== 'object') {
    return 0;
  }

  const body = parsed as Record<string, any>;
  const candidates = [
    body.retryAfterSeconds,
    body.error?.details?.retryAfterSeconds,
    body.error?.retryAfterSeconds,
  ];

  const seconds = candidates
    .map(value => Number(value))
    .find(value => Number.isFinite(value) && value > 0);

  return seconds ? Math.ceil(seconds) : 0;
};

export const getSmsRetryAfterSeconds = (errorOrBody: unknown): number => {
  if (errorOrBody && typeof errorOrBody === 'object' && !(errorOrBody instanceof Error)) {
    const fromBody = pickRetryAfterSeconds(errorOrBody);
    if (fromBody > 0) {
      return fromBody;
    }
  }

  const raw = errorOrBody instanceof Error ? errorOrBody.message : String(errorOrBody ?? '');
  if (!raw) {
    return 0;
  }

  try {
    return pickRetryAfterSeconds(JSON.parse(raw));
  } catch {
    return 0;
  }
};
